import React, { useCallback, useContext, useEffect, useState, useRef } from 'react';
import i18n from '../../../i18n';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { AppSettingsVar } from '../../../_project/settings';
import PopoverFormButton from '../Buttons/PopoverFormButton';
import ModalFormContext from '../../../store/ModalFormContext';
import Icon from '../../../icons/Icon';
import AsyncSelect from 'react-select/async';

const SelectSearch = ({
  fieldName,
  label,
  wrapperClass = '',
  hideLabel = false,
  allowNull = false,
  allowBlank = false,
  nullLabel = null,
  many=false,
  value = '',
  errors = [],
  popoverTarget = null,
  helpText = '',
  selectFormUrl = '',
  selectFormPK = null,
  selectFormGET = '',
  selectAddField = '',
  selectUrl = '',
  selectUrlConfig = {},
  parent = '',
  style = {},
  options = [],
  onChange = () => {},
  pk = null,
  disabled = false
}) => {
  // const [element, setElement] = useState(null);
  const [inputValue, setInputValue] = useState(value);
  const [choices, setChoices] = useState([]);
  const [showPopover, setShowPopover] = useState('');
  const [action, setAction] = useState(null);
  const timeoutRef = useRef(null);
  const context = useContext(ModalFormContext)

  const localOnChange = useCallback((e) => {
    if(many){
      e.value = e.map(e => e.value)
      e.label = e.length + ' ' + label
    }
    setInputValue(e?.value)
    onChange({'name':fieldName, 'value': e?.value, 'label': e?.label})
  }, [onChange])

  useEffect(() => {
    const data = options?.map( (option) => {
      return {value:option.id, label:option.label} 
    })
    if(allowNull && !many){
      data.unshift({value:'', label:nullLabel  || i18n.t('Select an option')})
    }
    setChoices(data)
  }, [options, allowNull, many])

  useEffect(() => {
    setInputValue(value)
  }, [])

  useEffect(() => {
    setAction(context.forms.find(e => e.action_id === selectFormUrl))
  }, [selectFormUrl])

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [])

  const insertTag =  useCallback( (data, tag)=> { 
    if(!data){
      return null 
    }
    setChoices(choices => [...choices.filter(e => e.value !== data), {value: data, label: tag}])
    var new_value;
    if(many){
      new_value = [...inputValue.map(e => ({value: e, label: ''})),  {value: data, label: tag}]
    }
    else{
      new_value = {value: data, label: tag}
    }
    localOnChange(new_value)
    return data
}, [inputValue])


  const handleCreate = useCallback( (inputValue) => {
    if(action){
      setShowPopover(inputValue)
    }
  }, [action])

  const styles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: 'transparent',
      border: state.isFocused ? '1px solid var(--bs-primary)' : '1px solid var(--bs-border-color)',
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
      position: 'absolute',
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    })
  }
  const theme = (theme) =>{
    return ({
    ...theme,
    borderRadius: 'var(--bs-border-radius)',
    colors: {
      ...theme.colors,
      backgroundColor: 'transparent',
      primary25: 'var(--bs-light)',
      primary: 'var(--bs-primary)',
      danger: 'var(--bs-danger)',
    },
    })}
    
  var Component, additionalProps = {};

  if(action){
    Component = CreatableSelect
  }
  else if(selectUrl){
    Component = AsyncSelect
    additionalProps = {
      'loadOptions': (inputValue, callback) => {
        // Clear any existing timeout
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        // Set a new timeout for 300ms
        timeoutRef.current = setTimeout(() => {
          fetch(selectUrl + '?search=' + inputValue)
          .then(response => response.json())
          .then(data => {
            callback(data.results.map(item => ({id:selectUrlConfig.detailFilterId||'id', label:selectUrlConfig.detailField||'name'})))
          })
          .catch(error => {
            callback([{id:'', label:i18n.t('No results found')}])
          })
        }, selectUrlConfig.delay || 300);
      }
    }
  }
  else{
    Component = Select
  }
const values = inputValue ? many ? choices.filter(option => inputValue.includes(option.value)) : choices.find(option => option.value === inputValue) : []
return<div className={`select-search-wrapper d-flex align-items-center ${style.className || ''}`}>
    <Component
        id={pk ? pk + '_' + fieldName : fieldName}
        className={`w-100 react-select-container ${errors.length > 0 ? 'is-invalid' : ''}`}
        classNamePrefix="react-select"
        isMulti={many}
        closeMenuOnSelect={!many}
        name={fieldName}
        onCreateOption={handleCreate}
        onChange={ localOnChange }
        isClearable={allowNull}
        // menuIsOpen={true}
        // onUnselect={ localOnChange }
        data={choices}
        // defaultValue={options.find(option => option.id === inputValue)}
        value={values}
        options={choices || []}
        defaultOptions={choices || []}
        menuPortalTarget={popoverTarget}
        menuPosition="absolute"
        styles={styles}
        theme={theme}
        isDisabled={disabled}
        {...additionalProps}
      />
    {action && 
      <PopoverFormButton
        id={selectFormPK}
        element={action} 
        url={action.form_url.includes('?') ? action.form_url + '&' + selectAddField + '=' + showPopover + "&" + selectFormGET : action.form_url + '?' + selectAddField + '=' + showPopover + "&"  + selectFormGET} 
        className={'btn btn-sm ms-1 px-2 my-auto rounded ' + AppSettingsVar.button_class} 
        name={''} 
        showPopover={showPopover}
        field={fieldName}
        finalizeTag={insertTag}
      >
        {selectFormPK ? <Icon name={"ICON_EDIT"} className={''}/> : <Icon name={"ICON_PLUS"} className={''}/>}
      </PopoverFormButton>
    }
  </div> 
};

export default SelectSearch;
